import { Button, Modal } from '@sequencehq/core-components'
import {
  DiscountEditorMode,
  DiscountEditorRootProps
} from 'modules/Cube/view/common/drawers/discountEditor/drawer/discountEditor.types'
import { useDiscountEditor } from 'modules/Cube/view/common/drawers/discountEditor/drawer/domainManagement/useDiscountEditor.domain'
import {
  DiscountEditorProvider,
  useDiscountEditorContext
} from 'modules/Cube/view/common/drawers/discountEditor/drawer/domainManagement/useDiscountEditorContext'
import { FC } from 'react'
import { DiscountEditorForm } from './DiscountEditorForm/DiscountEditorForm'
import { match } from 'ts-pattern'

const getDrawerTitle = (mode: DiscountEditorRootProps['mode']) => {
  return match(mode)
    .with(DiscountEditorMode.CREATE, () => 'Add discount')
    .with(DiscountEditorMode.VIEW, () => 'View discount')
    .with(DiscountEditorMode.EDIT, () => 'Edit discount')
    .exhaustive()
}

const getSaveText = (mode: DiscountEditorRootProps['mode']) => {
  return match(mode)
    .with(DiscountEditorMode.CREATE, () => 'Add discount')
    .with(DiscountEditorMode.VIEW, () => 'Update discount')
    .with(DiscountEditorMode.EDIT, () => 'Update discount')
    .exhaustive()
}

const DiscountEditorDrawer = (props: { onClose: () => void }) => {
  const discountEditorContext = useDiscountEditorContext()

  return (
    <Modal variant="drawer" isOpen onClose={props.onClose}>
      <Modal.Header onClose={props.onClose} showCloseButton>
        {getDrawerTitle(discountEditorContext.editor.mode)}
      </Modal.Header>
      <Modal.Content>
        <DiscountEditorForm />
      </Modal.Content>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => discountEditorContext.functions.saveDiscount()}
          data-testid="discountEditor.submit"
          disabled={
            discountEditorContext.editor.mode === DiscountEditorMode.VIEW
          }
        >
          {getSaveText(discountEditorContext.editor.mode)}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export const DiscountEditorRoot: FC<DiscountEditorRootProps> = props => {
  const discountEditorDomain = useDiscountEditor(props)

  return (
    <DiscountEditorProvider value={discountEditorDomain}>
      <DiscountEditorDrawer onClose={props.onClose} />
    </DiscountEditorProvider>
  )
}
